module.exports = "<div class=\"well padding-v-large\">\n  <h1 class=\"margin-b-large block\">Acquisto Campionario completato</h1>\n\n  <h2 class=\"margin-b-large block\">Grazie per aver effettuato il tuo acquisto<br /> A breve riceverai una e-mail di conferma</h2>\n\n  <img class=\"img-responsive margin-v-large\" src=\"/Content/images/configurator/logo.png\" alt=\"topcolor logo\" width=\"50%\">\n\n\n\n\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/campionario-completed.component.html
// module id = 604
// module chunks = 1